'use client';

import { type RoadMapUpdate } from '@/domain/roadmap/types';
import { TextField } from '@andritzot/metris-web-ui/inputs/textfield';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { type Control, Controller } from 'react-hook-form';

import { FieldActionsWrapper } from './shared/FieldActionsWrapper';

interface DescriptionFieldProps {
  viewOnly: boolean;
  control: Control<RoadMapUpdate, unknown>;
}

export function DescriptionField({ viewOnly, control }: Readonly<DescriptionFieldProps>) {
  return (
    <Box sx={{ py: 0.75 }}>
      <Controller
        name="description"
        control={control}
        rules={{ required: 'Required' }}
        render={({ field, fieldState: { error } }) => (
          <FieldActionsWrapper>
            <TextField
              {...field}
              label="Description"
              required
              disabled={viewOnly}
              fullWidth
              multiline
              rows={6}
              size="small"
              slotProps={{ htmlInput: { maxLength: 1000 } }}
              error={!!error}
              helperText={error?.message}
            />
          </FieldActionsWrapper>
        )}
      />
    </Box>
  );
}
